import { formatCompactValue, toneColor, asNumber } from "../../lib/kernelFormat.js";
import { HeroNumber, pickField } from "./shared.jsx";

export const kind = "stat";

export function Component({ spec, data }) {
    // Only pick a value/delta when the spec actually names the field —
    // pickField's "no field" fallback returns the whole `data` object,
    // which round-trips through formatValue as "[object Object]".
    const value = spec.valueField ? pickField(data, spec.valueField) : pickField(data, null);
    const delta = spec.deltaField ? pickField(data, spec.deltaField) : null;
    const deltaText = delta != null ? formatCompactValue(delta, spec.deltaFormat || spec.format) : null;
    const deltaTone = (() => {
        const n = asNumber(delta);
        if (n == null) return "muted";
        if (spec.tone) return spec.tone;
        return n > 0 ? "good" : n < 0 ? "bad" : "muted";
    })();

    return (
        <div className="rounded-[2px] border border-[color:var(--line)] bg-[color:var(--panel-soft)] px-[14px] py-[12px]">
            <div className="text-[10px] uppercase tracking-[0.14em] text-[color:var(--muted-soft)]">
                {spec.label || ""}
            </div>
            <div className="mt-[4px] flex items-baseline gap-[10px]">
                <HeroNumber
                    value={value}
                    format={spec.format}
                    tone={spec.tone}
                    className="font-mono text-[22px] leading-[1.05] text-[color:var(--ink)]"
                />
                {deltaText != null ? (
                    <span
                        className="text-[11px]"
                        style={{ color: toneColor(deltaTone) }}
                    >
                        {Number(delta) > 0 ? "▲" : Number(delta) < 0 ? "▼" : "·"} {deltaText}
                    </span>
                ) : null}
            </div>
            {spec.sublabel ? (
                <div className="mt-[2px] text-[10.5px] text-[color:var(--muted-soft)]">
                    {spec.sublabel}
                </div>
            ) : null}
        </div>
    );
}
